import React from 'react';
import { CheckCircle, XCircle, ShieldAlert, Users } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


export type SurveyStatus = 'complete' | 'terminate' | 'qualitySecurity' | 'quotaFull';

const statusConfig: Record<
  SurveyStatus,
  { label: string; icon: React.ElementType; textColor: string; bgColor: string; borderColor: string }
> = {
  complete: {
    label: 'Complete',
    icon: CheckCircle,
    textColor: 'text-green-400',
    bgColor: 'bg-green-500/12',
    borderColor: 'border-green-500/30',
  },
  terminate: {
    label: 'Terminate',
    icon: XCircle,
    textColor: 'text-red-400',
    bgColor: 'bg-red-500/12',
    borderColor: 'border-red-500/30',
  },
  qualitySecurity: {
    label: 'Quality / Security',
    icon: ShieldAlert,
    textColor: 'text-purple-400',
    bgColor: 'bg-purple-500/12',
    borderColor: 'border-purple-500/30',
  },
  quotaFull: {
    label: 'Quota Full',
    icon: Users,
    textColor: 'text-amber-400',
    bgColor: 'bg-amber-500/12',
    borderColor: 'border-amber-500/30',
  },
};

interface StatusBadgeProps {
  status: SurveyStatus;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium tabular-nums
        ${config.bgColor} ${config.textColor} ${config.borderColor}
        ${size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs'}`}
    >
      <Icon size={size === 'sm' ? 11 : 12} />
      {config.label}
    </span>
  );
}

export { statusConfig };